import React from 'react';
import { useMediaQuery } from '@mui/material';
import HorizontalTable from './HorizontalTable';
import VerticalTable from './VerticalTable';

const Table = ({ aiSkuMappings, pageSize, pageNumber }) => {
  const isMobile = useMediaQuery('(max-width:1218px)');
  if (isMobile) {
    return (
      <HorizontalTable
        aiSkuMappings={aiSkuMappings}
        pageSize={pageSize}
        pageNumber={pageNumber}
      />
    );
  } else {
    return (
      <VerticalTable
        style={{ width: '100%', marginY: '14.5px' }}
        aiSkuMappings={aiSkuMappings}
        pageSize={pageSize}
        pageNumber={pageNumber}
      />
    );
  }
};

export default Table;
